import { Spinner } from "@shopify/polaris"
import classNames from "classnames"
import React from "react"

interface ProSpinnerProps {
  loading: boolean
  className?: string
  wrapperStyle?: React.CSSProperties
  spinnerStyle?: React.CSSProperties
  children: React.ReactNode
}
const ProSpinner = (props: ProSpinnerProps) => {
  const { children, loading, className, spinnerStyle, wrapperStyle } = props
  return (
    <>
      {loading ? (
        <div
          className={classNames("pro-spinner", className)}
          style={wrapperStyle}
        >
          <div className="pro-spinner--loading" style={spinnerStyle}>
            <Spinner hasFocusableParent={false} />
          </div>
          {children}
        </div>
      ) : (
        children
      )}
    </>
  )
}

export default ProSpinner
